import { useEffect, useState } from "react";
import adminApi from "../lib/adminApi";

// A 1x1 transparent gif used until the authenticated image blob arrives.
const PLACEHOLDER = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

// Loads an admin image (turntable thumbnail) via adminApi so the Shopify session token is attached.
// A plain <img src> cannot send the Authorization header, and archived ducks are hidden from public endpoints.
export function AdminImg({ src, alt, className, testid, fallback, ...rest }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    if (!src) {
      setUrl(fallback || null);
      return undefined;
    }
    adminApi
      .get(src, { responseType: "blob" })
      .then(({ data }) => {
        if (!active) return;
        if (data && data.type && data.type.startsWith("image/")) {
          objectUrl = URL.createObjectURL(data);
          setUrl(objectUrl);
        } else if (fallback) {
          setUrl(fallback); // local DB has no image (e.g. duck lives in another environment) → public share image
        }
      })
      .catch(() => {
        if (active && fallback) setUrl(fallback);
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, fallback]);

  return <img data-testid={testid} src={url || PLACEHOLDER} alt={alt} className={className} loading="lazy" {...rest} />;
}
